import React from "react";
import { Route } from "react-router-dom";
import {
  Client,
  Employee,
  Dashboard,
  AddEmployee,
  EmployeeProfile,
  AddClient,
  Vendor,
  AddVendor,
  Timesheet,
  TimesheetSettings,
  ClientDetails,
  TimesheetDetails,
  VendorDetails,
  Invoices,
  Immigration,
  AccountsPayable,
  EOnboarding,
  Payroll,
  Payments,
  MailSent,
  AccountsPayableSettings,
  BulkInvoices,
  Addinvoices,
  EmailSent,
  CreatePayments,
  PayDataCenter,
  SalaryProfileConfigurations,
  SalaryProfileView,
  ExitEmployeesTab,
  CreateAccountsPayableInvoice,
  QuickBooks,
  Documents,
  QbIntegrationProfiles,
  PaymentsFromQb,
  InvoicesFromQb,
  APInvoicesFromQb,
  APPaymentsFromQb,
  // EOnboardingSettings,
  Notifications,
  CheckList,
  AddCheckList,
  IncentiveDashboard,
  Activities
} from "../pages";
import InnerMainLayout from "../pages/InnerPages/_layout/InnerMainLayout";
import { ProtectedRoute } from "../components";

const WfRoutes = () => {
  return (
    <>
      <Route element={<InnerMainLayout />}>
        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
         <Route
            path="/incentive"
            element={<IncentiveDashboard />}
          />
        {/* Notification */}
        <Route path="/notifications" element={<Notifications />} />

        {/* Components List moved to CommonRoutes for cross-portal access */}

        {/* Employees */}
        <Route path="/employee" element={<Employee />} />
        <Route path="/employee/add-employee" element={<AddEmployee />} />
        <Route
          path="/employee/employee-profile"
          element={<EmployeeProfile />}
        />
        <Route
          path="/employee/employee-profile/timesheet"
          element={<TimesheetDetails />}
        />
        <Route
          path="/employee/employee-profile/mail-sent"
          element={<MailSent />}
        />
        <Route
          path="/employee/payroll/activities"
          element={<Activities />}
        />

        {/* Timesheet Routes */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["ADMIN", "HR", "FINANCE", "EMPLOYEE"]}
            />
          }
        >
          <Route path="/timesheet" element={<Timesheet />} />
          <Route
            path="/timesheet/timesheet-settings"
            element={<TimesheetSettings />}
          />
        </Route>

        {/* Client Routes */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["ADMIN", "HR", "FINANCE", "IMMIGRATION"]}
            />
          }
        >
          <Route path="/client" element={<Client />} />
          <Route path="/client/add-client" element={<AddClient />} />
          <Route path="/client/client-details" element={<ClientDetails />} />
        </Route>

        {/* Vendor Routes */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["ADMIN", "HR", "FINANCE", "IMMIGRATION"]}
            />
          }
        >
          <Route path="/vendor" element={<Vendor />} />
          <Route path="/vendor/add-vendor" element={<AddVendor />} />
          <Route path="/vendor/vendor-details" element={<VendorDetails />} />
        </Route>

        {/* Invoices Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/invoices/bulk-invoices" element={<BulkInvoices />} />
          <Route path="/invoices/add-invoices" element={<Addinvoices />} />
          <Route path="/invoices/mail-sent" element={<EmailSent />} />
        </Route>

        {/* Immigration Routes */}
        <Route
          element={<ProtectedRoute allowedRoles={["ADMIN", "IMMIGRATION"]} />}
        >
          <Route path="/immigration" element={<Immigration />} />
        </Route>

        {/* Accounts Payable Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/accounts-payable" element={<AccountsPayable />} />
          <Route
            path="/accounts-payable/Invoice"
            element={<CreateAccountsPayableInvoice />}
          />
          <Route
            path="/accounts-payable/edit/:payableId"
            element={<CreateAccountsPayableInvoice />}
          />
          <Route
            path="/accounts-payable/settings"
            element={<AccountsPayableSettings />}
          />
        </Route>

        {/* E-Onboarding Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/e-onboarding" element={<EOnboarding />} />
          <Route path="/e-onboarding/documents" element={<Documents />} />
          <Route path="/e-onboarding/checklist" element={<CheckList />} />
          <Route path="/e-onboarding/addchecklist" element={<AddCheckList />} />
          <Route path="/e-onboarding/editchecklist" element={<AddCheckList />} />
        </Route>

        {/* Payroll Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/payroll" element={<Payroll />} />
          <Route path="/payroll/pay-data-center" element={<PayDataCenter />} />
          <Route
            path="/payroll/salary-profile-configaration"
            element={<SalaryProfileConfigurations />}
          />
          <Route
            path="/payroll/salary-profile-view"
            element={<SalaryProfileView />}
          />
          <Route path="/payroll/exit-employee" element={<ExitEmployeesTab />} />
        </Route>

        {/* Payments Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/add-payments" element={<CreatePayments />} />
          <Route
            path="/payments/add-payments/mail-sent"
            element={<MailSent />}
          />

        </Route>

        {/* QuickBooks Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "FINANCE"]} />}>
          <Route path="/quickbooks" element={<QuickBooks />} />
          <Route
            path="/quickbooks/qb-integration-profile"
            element={<QbIntegrationProfiles />}
          />
          <Route
            path="/quickbooks/invoices-from-qb"
            element={<InvoicesFromQb />}
          />
          <Route
            path="/quickbooks/payments-from-qb"
            element={<PaymentsFromQb />}
          />
          <Route
            path="/quickbooks/ap-invoices-from-qb"
            element={<APInvoicesFromQb />}
          />
          <Route
            path="/quickbooks/ap-payments-from-qb"
            element={<APPaymentsFromQb />}
          />
         
          
        </Route>
      </Route>
    </>
  );
};

export default WfRoutes;
